module.exports = __webpack_public_path__ + "static/media/gold-club-video.3d736427.png";